export const DEFAULT_WALLET_INJECTION_ERROR = 'Failed to connect to wallet';

export function getErrorMessage(error: unknown) {
  return error instanceof Error ? error.message : 'Something went wrong. Please try again.';
}
